import { __extends } from "tslib";
import Resource from './resource';
var NPSModule = (function (_super) {
    __extends(NPSModule, _super);
    function NPSModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NPSModule.prototype.submitScore = function (score, npsMessageId) {
        return this.client.http.post("/nps", { score: score, npsMessageId: npsMessageId }).then(function (_a) {
            var data = _a.data;
            return data.data;
        });
    };
    NPSModule.prototype.submitFeedback = function (npsMessageId, response) {
        return this.client.http.patch("/nps/" + npsMessageId, { response: response }).then(function (_a) {
            var data = _a.data;
            return data.data;
        });
    };
    return NPSModule;
}(Resource));
export default NPSModule;
//# sourceMappingURL=nps.js.map